<template>
    <Head title="Create New User"/>
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl leading-tight">
                Create New Admin User
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form enctype="multipart/form-data"
                      @submit.prevent="create.post(requestUrl, { preserveScroll: true})"
                      class="w-full">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Name</admin-app-label>
                            <input-basic
                                placeholder="Name"
                                v-model="create.name"
                                :error="errors['name']"
                            />
                            <input-error v-if="errors['name']">
                                {{ errors.name }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Email Address</admin-app-label>
                            <input-basic
                                placeholder="Email Address"
                                v-model="create.email"
                                :error="errors['email']"
                            />
                            <input-error v-if="errors['email']">
                                {{ errors.email }}
                            </input-error>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Password</admin-app-label>
                            <input-basic
                                type="password"
                                placeholder="Password"
                                v-model="create.password"
                                :error="errors['password']"
                            />
                            <input-error v-if="errors['password']">
                                {{ errors.password }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Confirm Password</admin-app-label>
                            <input-basic
                                type="password"
                                placeholder="Confirm Password"
                                v-model="create.password_confirmation"
                                :error="errors['password_confirmation']"
                            />
                            <input-error v-if="errors['password_confirmation']">
                                {{ errors.password_confirmation }}
                            </input-error>
                        </div>
                    </div>
                    <app-button type="submit" :disabled="create.processing" class="mt-8">Create</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import {Head, useForm} from "@inertiajs/inertia-vue3";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated.vue";
import Label from "@/Components/Label";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import AppButton from "@/Components/AppButton";
import InputError from "@/Components/Forms/Inputs/InputError";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";

export default {
    name: "Create",
    components: {
        BreadCrumbs,
        AdminAppLabel,
        AppButton,
        InputBasic,
        Label,
        BreezeAuthenticatedLayout,
        Head,
        InputError
    },
    props: {
        errors: Object,
        config: Object,
        requestUrl: {
            type: String,
            default: "/admin/users"
        }
    },
    data() {
        return {
            navItems: [
                {title: "Users", path: "/admin/users"},
                {title: "Create New", path: "/admin/users/create"},
            ],
            create: useForm(
                {
                    name: "",
                    email: "",
                    password: "",
                    password_confirmation: ""
                }
            )
        };
    }
};
</script>
